import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_NOTIFY_MARKETPLACE } from '../../../constants';

import style from '../../style.module.less';

const options = [
  {
    id: 0,
    name: 'Notify Marketplace',
    value: true,
  },
  {
    id: 1,
    name: 'Do Not Notify Marketplace',
    value: false,
  },
];

const NotifyMarketplaceBulkUpdate = () => {
  const { bulkUpdateFulfillmentPlans } = useContext(MarkAsShippedContext);

  return (
    <DropdownMenu className={style['bulk-update-item']}>
      <DropdownMenuToggler>
        <FormattedMessage defaultMessage='Notify Marketplace' description='markAsShippedmodal.button.notifyMarketplace' id='rrDqsS' />
      </DropdownMenuToggler>
      {options.map((option) => (
        <DropdownMenuItem
          key={option.id}
          onClick={() => bulkUpdateFulfillmentPlans(MARK_AS_SHIPPED_NOTIFY_MARKETPLACE, JSON.parse(option.value))}
        >
          {option.name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

export default NotifyMarketplaceBulkUpdate;
